const constants = {
    retailers: 'https://books2read.com/u/3LdnWJ',
    blurb: "https://books2read.com/b/3LdnWJ"
};

export default constants;